"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChoosePoliticalAgenda = void 0;
const OrOptions_1 = require("../inputs/OrOptions");
const SelectOption_1 = require("../inputs/SelectOption");
const DeferredAction_1 = require("./DeferredAction");
class ChoosePoliticalAgenda {
    constructor(player, party, turmoil) {
        this.player = player;
        this.party = party;
        this.turmoil = turmoil;
        this.priority = DeferredAction_1.Priority.DEFAULT;
    }
    execute() {
        const staticAgendas = this.turmoil.politicalAgendasData.staticAgendas;
        const partyAgenda = staticAgendas.get(this.party.name);
        const agenda = {
            bonusId: partyAgenda.bonusId,
            policyId: partyAgenda.policyId,
        };
        const players = this.player.game.getPlayers();
        const bonuses = this.party.bonuses.map((bonus) => {
            let description = bonus.description + ' [';
            description += players.map((player) => player.name + ': ' + bonus.getScore(player)).join(' / ') + ']';
            return new SelectOption_1.SelectOption(description, 'Select', () => {
                agenda.bonusId = bonus.id;
                this.turmoil.politicalAgendasData.currentAgenda = agenda;
                staticAgendas.set(this.party.name, { bonusId: bonus.id, policyId: partyAgenda.policyId });
                this.turmoil.onAgendaSelected(this.player.game);
                return undefined;
            });
        });
        const orBonuses = new OrOptions_1.OrOptions(...bonuses);
        orBonuses.title = 'Change ' + this.party.name + ' ruling bonus';
        const policies = this.party.policies.map((policy) => new SelectOption_1.SelectOption(policy.description, 'Select', () => {
            agenda.policyId = policy.id;
            this.turmoil.politicalAgendasData.currentAgenda = agenda;
            staticAgendas.set(this.party.name, { bonusId: partyAgenda.bonusId, policyId: policy.id });
            this.turmoil.onAgendaSelected(this.player.game);
            return undefined;
        }));
        const orPolicies = new OrOptions_1.OrOptions(...policies);
        orPolicies.title = 'Change ' + this.party.name + ' ruling policy';
        return new OrOptions_1.OrOptions(orBonuses, orPolicies);
    }
}
exports.ChoosePoliticalAgenda = ChoosePoliticalAgenda;
//# sourceMappingURL=ChoosePoliticalAgenda.js.map